import React, { useState } from "react";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import { Api_Get_Transactions_AGW } from "../../../../helper/api/ApiGateway";
import refresh from "../../../../static/iconmonstr-refresh-1.svg";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  loadMore = () => {
    Api_Get_Transactions_AGW(
      this.props.dispatch,
      {
        page: this.props.page,
      },
      (call) => {
      }
    );
  };


  render() {
    if (this.props.OrderListError) {
      return (
        <div className="NoOrderContainer">
          <div className="NoOrderInner mrb90">
            <span className="NoOrderTitle">
              {" "}
              <Trans i18nKey={"loadingError"}> </Trans>{" "}
            </span>
            <span className="NoOrderDescription">
              {" "}
              <Trans i18nKey={"retry"}>
                {" "}
              </Trans>{" "}
            </span>
            <img className="NoOrderNewOrder" src={refresh} onClick={this.loadMore}/>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  OrderListError: state.Transactions.OrderListError,
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
